var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "s_linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "21px",
    width: 21,
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n                .st2{fill:#a9c5d7;}\r\n            ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17,17L17,17L17,17l0-6.2c0-3.1-0.7-5.4-4.2-5.4c-1.7,0-2.9,0.9-3.3,1.8h0V5.6H6V17h3.5v-5.6                 c0-1.5,0.3-2.9,2.1-2.9c1.8,0,1.8,1.7,1.8,3V17L17,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.3,5.7h3.5V17H0.3L0.3,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,0C0.9,0,0,0.9,0,2s0.9,2.1,2,2.1s2-0.9,2-2.1C4.1,0.9,3.2,0,2,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.93cd554bdbef17756dedd683fb2b0f69.svg";
export { ForwardRef as ReactComponent };